export default __webpack_public_path__ + "static/media/signup06tour-slide4-a.8119fcc5.jpg";